/**
 * Helper storage (localStorage or sessionStorage)
 * @param {string} type      Storage type (localStorage or sessionStorage)
 * @param {string} prefix    Namespace name
 * @param {string} separator A character to separate the prefix from the key
 */
export function HelperStorage( type , prefix , separator ) {
    this.prefix = prefix;
    this.type = type;
    this.separator = separator;
    this.length = 0;
}

HelperStorage.prototype.get = function( key ) {
    return window[ this.type ].getItem( this.prefix + this.separator +  key );
};

HelperStorage.prototype.set = function( key, value ) {
    this.length += 1;
    window[ this.type ].setItem( this.prefix + this.separator +  key, value );
};

HelperStorage.prototype.remove = function( key ) {
    this.length -= 1;
    window[ this.type ].removeItem( this.prefix + this.separator +  key );
};

HelperStorage.prototype.removeByGroup = function( to_delete ) {
    for (var i = 0; i < to_delete.length; i++) {
        window[ this.type ].removeItem( to_delete[i] );
        this.length -= 1;
     };
};

HelperStorage.prototype.clear = function() {
    var storage_array = window[ this.type ],
        to_delete = [];

    for (var i = 0; i < storage_array.length; i++) {
        if ( storage_array.key(i).indexOf( this.prefix + this.separator ) === 0 ) {
            to_delete.push( storage_array.key(i) );
        }
    }; 
    this.removeByGroup( to_delete );
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/storage-helper.ts